export const url = "https://api.krushisetu.com";
// export const url = "http://localhost:5000";
export const admin = "maheshbusiness50@gmail.com";

// export const rzkey = `rzp_test_RuGaghXNGVGs9W`;

//live razorpay key
export const rzkey = `rzp_live_JTkrEb0HxcWDEx`;
